export enum UserGuideControls {
  STEP = 'step',
  FIELD_ARRAY_STEPS = 'guide_content.steps',
}

export enum UserGuideActionType {
  HIGHLIGHT = 'highlight',
  CLICK = 'click',
}
